import { render, staticRenderFns } from "./AdvertisementMark.vue?vue&type=template&id=1573322a&scoped=true&"
import script from "./AdvertisementMark.vue?vue&type=script&lang=js&"
export * from "./AdvertisementMark.vue?vue&type=script&lang=js&"
import style1 from "./AdvertisementMark.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1573322a",
  null
  
)

export default component.exports